import { render } from "./BaptismDialog.vue?vue&type=template&id=946eb298"
import script from "./BaptismDialog.vue?vue&type=script&lang=js"
export * from "./BaptismDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__